import type { ImgHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { cx } from 'src/utils/cx'
import { useColorModeContext } from '../ColorModeProvider'
import {
  CHIBI_FALLBACK,
  isValidMioImageUrl,
  MioExpression,
  type MioExpressionType,
  type MioVariant,
} from './utils'

export { MioExpression }
export type { MioExpressionType }

export type MioImageProps = {
  expression: MioExpressionType
  /**
   * Will follow colorMode if unspecified
   */
  variant?: MioVariant
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'>

export function MioImage(props: MioImageProps) {
  const { themeType } = useColorModeContext()
  const { expression, alt, variant, ...rest } = props
  const { t } = useTranslation(['common'])

  // Note: This is a new series of mio images representing a different set of styles, named "chibi". So we're using it for the resource name.
  const translatedSrc = t(`common:resources.chibi.${expression}`, {
    context: variant ?? themeType,
  })
  const src = isValidMioImageUrl(translatedSrc)
    ? translatedSrc
    : CHIBI_FALLBACK[expression][variant ?? themeType]

  return (
    <img
      src={src}
      alt={alt ?? `Mio with expression ${expression}`}
      {...rest}
      className={cx(rest.className, 'object-contain')}
    />
  )
}
